export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_10011_USER_AND_EVALUATION_TYPE_SELECTION': 'User and Evaluation Type Selection',
    '_10012_SELECT_AN_EVALUATION_TYPE': 'Select an Evaluation Type',
    '_10013_SELECT_EVALUATION': 'Select Evaluation'
};
